import './Card.css'

const Card = () => {
  return (
    <>
    <div className='grid-container_car'>
        <div className='wrapper'>
            <div className='card_area'>
                <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card'></div>
                    </div>
                    <div className='info'>
                        <h2>Ajvar stark 2,4kg</h2>
                        <div className='btn'>
                            <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card2'></div>
                    </div>
                    <div className='info'>
                        <h2>Ajvar mild 2,4kg</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card3'></div>
                    </div>
                    <div className='info'>
                        <h2>Auberginepuré 4,2kg</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>
                <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card4'></div>
                    </div>
                    <div className='info'>
                        <h2>Svarta bönor 2,5kg</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>   
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card5'></div>
                    </div>
                    <div className='info'>
                        <h2>Yoghurt Dessert 10kg</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card6'></div>
                    </div>
                    <div className='info'>
                        <h2>Yoghurt Dessert 10kg</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card7'></div>
                    </div>
                    <div className='info'>
                        <h2>Extra Virgin olivolja Original 5 liter</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card8'></div>
                    </div>
                    <div className='info'>
                        <h2>Extra Virgin olivolja PDO Kalamata 5 liter</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card9'></div>
                    </div>
                    <div className='info'>
                        <h2>Fetaost Thessalias 2kg hel</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card10'></div>
                    </div>
                    <div className='info'>
                        <h2>Fetaost Thessalias 2kg skivad</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card11'></div>
                    </div>
                    <div className='info'>
                        <h2>Fetaost Thessalias 2kg tärnad</h2>
                        <div className='btn'>
                            <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
                 <div className='card_con'>
                    <div className='imgBox'>
                        <div className='img_card12'></div>
                    </div>
                    <div className='info'>
                        <h2>Hojiblanca gröna oliver med pimento 3kg</h2>
                        <div className='btn'>
                             <div className='button'>
                                Pris
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
</>
  )
}

export default Card